var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-available"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('i',{staticClass:"fa fa-check-circle-o"})])
}
var staticRenderFns = []

export { render, staticRenderFns }